import type from './Document.type';

const initialState = {
  ListData: [],
  totalCount: 0,
  crumbData: [],
  fileDataById: {},
  getAllFolderList: [],
  getAllSupplier: [],
};

const DocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DOCUMENT_LIST:
      return {
        ...state,
        ListData: [...state.ListData, ...action.payload.doc],
        totalCount: action?.payload?.totalCount,
      };
    case type.CLEAR_DOCUMENT_REDUCER:
      return {
        ...state,
        ListData: [],
        totalCount: 0,
        fileDataById: {},
        getAllFolderList: [],
      };
    case type.FETCH_BREAD_CRUMB_DATA:
      return {
        ...state,
        crumbData: action?.payload,
      };
    case type.GET_DOCUEMNT_BY_ID:
      return {
        ...state,
        fileDataById: action?.payload,
      };
    case type.GET_FOLDER_LIST:
      return {
        ...state,
        getAllFolderList: action?.payload,
      };
    case type.GET_SUPPLIER_LIST:
      return {
        ...state,
        getAllSupplier: action?.payload,
      };
    default:
      return state;
  }
};

export default DocumentReducer;
